import Api from './Api';
import Configuracao from '../util/Configuracao';

class DemonstrativoApi extends Api {
  async consultarDemonstrativos () {
    try {
      const urlConsultarDemonstrativos = Configuracao.getConfiguracao().urlConsultarDemonstrativos;
      const response = await this.fetch(urlConsultarDemonstrativos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDemonstrativosPorFiltro (numDemonstrativo, seqPrestador, codFatura) {
    try {
      const urlConsultarDemonstrativosPorFiltro = Configuracao.getConfiguracao().urlConsultarDemonstrativosPorFiltro + numDemonstrativo + '/' + seqPrestador + '/' + codFatura;
      const response = await this.fetch(urlConsultarDemonstrativosPorFiltro);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarDemonstrativo (demonstrativo) {
    try {
      const urlAlterarDemonstrativo = Configuracao.getConfiguracao().urlAlterarDemonstrativo;
      await this.fetch(urlAlterarDemonstrativo, 'put', demonstrativo);
    } catch (error) {
      console.error(error);
    }
  }
  async montarGrafico (filter) {
    try {
      const urlConsultarGrafico = Configuracao.getConfiguracao().urlConsultarGrafico + filter.ano + '/tipo/' + filter.tipo;
      const response = await this.fetch(urlConsultarGrafico);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDemonstrativosNaoPagos (numDemonstrativo) {
    try {
      const urlConsultarDemonstrativosNaoPagos = Configuracao.getConfiguracao().urlConsultarDemonstrativosNaoPagos + numDemonstrativo;
      const response = await this.fetch(urlConsultarDemonstrativosNaoPagos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default DemonstrativoApi;
